import { IS_PRODUCTION } from 'constants/app'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{
  width: number
  leftMargin: number
  rightMargin: number
  leftPadding: number
  rightPadding: number
}>`
  width: ${({ width }) => width}px;
  min-width: ${({ width }) => width}px;

  margin-left: ${({ leftMargin }) => leftMargin}px;
  margin-right: ${({ rightMargin }) => rightMargin}px;
  padding-left: ${({ leftPadding }) => leftPadding}px;
  padding-right: ${({ rightPadding }) => rightPadding}px;

  ${() =>
    !IS_PRODUCTION &&
    css`
      ins {
        background-color: ${({ theme }) => theme.palette.background.default};
        height: 100%;
        width: 300px;
      }
    `}
`

export const AdSlot = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;
`
